import { SET_ERROR } from 'services/context/assessmentContext/assessmentContext';

export const setError = (payload, dispatch) => {
  dispatch({
    type: SET_ERROR,
    payload: payload
  });
};
